import { IAvailableStore, ILocation } from 'types';
import { calcDistanceKm } from './distance';

export const sortStoresByDistance = (
    stores: IAvailableStore[],
    referenceLocation: ILocation
) => {
    return stores
        .map((store) => ({
            ...store,
            distanceKm: calcDistanceKm(
                {
                    lat: store.lat,
                    lng: store.lng,
                },
                referenceLocation
            ),
        }))
        .sort((storeA, storeB) => storeA.distanceKm - storeB.distanceKm);
};
